import { createModalEventManager } from "../../util/modalEvents/createModalEventManager";

type MissingDetailsAlertEvents = {
  dismissed: string;
  resumeUpdated: void;
};

/**
 * Broadcasts missing-detail alert dismissals across React roots / features via
 * DeviceEventEmitter.
 */
export const missingDetailsAlertEvents =
  createModalEventManager<MissingDetailsAlertEvents>("MissingDetailsAlert");
